import { NavLink } from "react-router-dom";

import { SummaryCard } from "../components/SummaryCard";
import { useContent } from "../hooks/useContent";
import { PageContainer } from "../layout/PageContainer";
import { api } from "../lib/api";
import { DetailCardGrid, DetailMetricGrid } from "./DeepDiveParts";

export function PrecedentPage() {
  const { data, loading, error } = useContent("precedent-page", api.getPrecedent);

  return (
    <PageContainer
      eyebrow="Supporting Detail - Market Support / Concept & Program"
      title="Precedent detail supporting Market Support and Concept & Program"
      lede="This route is the hyper-local precedent layer beneath Market Support and Concept & Program. It keeps the micro-area proof set available without presenting precedent as a standalone top-level investor case."
    >
      {loading ? <div className="loading-panel shimmer-card">Loading precedent summary...</div> : null}
      {error ? <div className="error-panel">{error}</div> : null}
      {data ? (
        <div className="stack-xl">
          <DetailMetricGrid
            items={[
              { title: "Reference Sales", value: `${data.referenceProperties.length}`, detail: "Hyper-local comparables" },
              { title: "Takeaways", value: `${data.takeaways.length}`, detail: "Key product signals" },
              { title: "Limits", value: `${data.limits.length}`, detail: "Why this is not a revenue proof set" },
              { title: "Status", value: data.status, detail: "Precedent summary status" }
            ]}
          />

          <DetailCardGrid
            items={data.referenceProperties.map((item) => ({
              eyebrow: "Reference Property",
              title: item.address,
              description: item.keyImplication,
              fields: [
                { label: "Sale Signal", value: item.saleSignal },
                { label: "Size", value: item.size },
                { label: "Beds / Baths", value: item.bedroomsBaths },
                { label: "Build Year", value: item.buildYear }
              ]
            }))}
          />

          <div className="grid-two">
            <SummaryCard eyebrow="Takeaways" title="Why the F St. set matters" description={data.overview}>
              <ul className="bullet-list">
                {data.takeaways.map((item) => (
                  <li key={item} className="bullet-item">{item}</li>
                ))}
              </ul>
            </SummaryCard>
            <SummaryCard eyebrow="Limits" title="What this precedent does not prove" description={data.currentInterpretation}>
              <ul className="bullet-list">
                {data.limits.map((item) => (
                  <li key={item} className="bullet-item">{item}</li>
                ))}
              </ul>
            </SummaryCard>
          </div>

          <SummaryCard eyebrow="Conclusion" title={data.status} description={data.conclusion} />

          <SummaryCard
            eyebrow="Parent Surfaces"
            title="Return to the commercial and program surfaces for the full investor read"
            description="Use this page when the micro-area precedent matters directly. Use the parent surfaces for the broader market logic and concept-selection posture."
          >
            <div className="row-wrap gap-sm overview-go-deeper-actions">
              <NavLink to="/market-support" className="link-button link-button-secondary">
                Review Market Support
              </NavLink>
              <NavLink to="/concept-program" className="link-button link-button-secondary">
                Review Concept & Program
              </NavLink>
            </div>
          </SummaryCard>
        </div>
      ) : null}
    </PageContainer>
  );
}
